import { AppState, AuthState } from 'acscp/store';
import { requestsStateKeyMatchesRequestType, RequestStatus } from 'acscp/store/requestsState';

export function tokenSelector(state: AppState): string | undefined {
    return state.auth.refreshToken;
}

export function sharingTokenSelector(state: AppState): string[] | undefined {
    return state.auth.sharingTokens;
}

export function authStateSelector(state: AppState): AuthState {
    return state.auth;
}

export function hasAuthenticationSelector(state: AppState): boolean {
    return !!state.auth.refreshToken || state.auth.sharingTokens.length > 0;
}

export function requestsNotInProgress(requestTypes: string[]): (state: AppState) => boolean {
    const requestsStateKeyMatchesRequestTypes =
        (key: string) => requestTypes.some(type => requestsStateKeyMatchesRequestType(key, type));

    return state => {
        const requestKeys = Object.keys(state.requests).filter(requestsStateKeyMatchesRequestTypes);

        const requestStates = requestKeys.map(key => state.requests[key]);

        return requestStates.every(request => request.status !== RequestStatus.InProgress);
    };
}

export function currentLocale(state: AppState): string {
    return state.intl.locale;
}
